<template>
  <rules-list :rules="rules" />
</template>

<script>
import { mapState } from 'vuex';

import RulesList from '@/components/rules/RulesList';

export default {
  name: 'RulesListContainer',
  components: {
    RulesList,
  },
  mounted() {
    this.$store.dispatch('rules/getCampaignRules', this.$route.params.campaignId);
  },
  computed: {
    ...mapState('rules', ['rules']),
  },
};
</script>



// WEBPACK FOOTER //
// RulesListContainer.vue?2630a1d1